import { Field, Form } from "react-final-form";
import { generatePath, useHistory, useParams } from "react-router-dom";

import { updateSearch } from "@/api/endpoints/searches";
import { useAlert } from "@/contexts/AlertContext";
import { ROUTES } from "@/routes_new";
import Button from "@components/Button";
import Container from "@components/Container";
import { FF_InputField } from "@components/Field";

import Remove from "../Remove";

import styles from "./GeneralLimited.module.css";

const GeneralLimited = () => {
  const history = useHistory();
  const { orgUuid, uuid } = useParams();

  const { alerts, patchAlert } = useAlert();
  const alert = alerts?.find((a) => a.uuid === uuid);

  const handleSave = async ({ title }) => {
    return updateSearch(uuid, { title }).then(() => {
      patchAlert(uuid, { title });
      history.push(
        generatePath(ROUTES.MENTION_DETAIL_ORGID, { uuid, orgUuid })
      );
    });
  };

  return (
    <Container>
      <Form
        className="querybuilder"
        onSubmit={handleSave}
        initialValues={{ title: alert?.title }}
      >
        {({ handleSubmit, submitting, pristine, dirty }) => (
          <form onSubmit={handleSubmit}>
            <Field
              styles={styles.field}
              required
              block
              render={FF_InputField}
              name="title"
              label={L.MENTIONS_QUERYBUILDER_TITLE_LABEL}
              placeholder={L.MENTIONS_QUERYBUILDER_TITLE_PLACEHOLDER}
            />

            <Button
              styles={styles.button}
              type="submit"
              variant="primary"
              data-testid="save-limited-alert-button"
              disabled={submitting || pristine || !dirty}
            >
              {L.MENTION_SETTING_SAVE_CHANGES}
            </Button>
          </form>
        )}
      </Form>
      <hr />
      <Remove />
    </Container>
  );
};

export default GeneralLimited;
